import React, { useState, useReducer } from "react";
import { SubmitButton } from "../../../core/SubmitButton";
import moment from "moment";
import { Countdown } from "../../common/event/Countdown";
import { rootReducer, AppState } from "../../../app-state";
export const Styleguide = () => {
    const [loadState, setLoadState] = useState('idle');
    const [percentage, setPercentage] = useState(null);
    const [state, dispatch] = useReducer(rootReducer, AppState);
    const busyDemo = () => {
        setLoadState('submitting');
        setTimeout(() => setPercentage(10), 500);
        setTimeout(() => setPercentage(20), 1000);
        setTimeout(() => setPercentage(30), 1500);
        setTimeout(() => setPercentage(40), 2500);
        setTimeout(() => setPercentage(90), 3500);
        setTimeout(() => setPercentage(null), 4000);
        setTimeout(() => setLoadState('saved'), 4500);
    };
    return (React.createElement("div", { className: "container" },
        React.createElement("h1", null, "Styleguide"),
        React.createElement("h2", null, "Submit button"),
        React.createElement(SubmitButton, { label: "Ulo\u017Eit", percentage: percentage, loadState: loadState, onClick: () => busyDemo() }),
        React.createElement("div", null,
            React.createElement("h2", null, "Countdown"),
            React.createElement("div", { className: "event-detail" },
                React.createElement("div", { className: " ed-intel " },
                    React.createElement("div", { className: "line " },
                        React.createElement("div", { className: "vle" },
                            React.createElement(Countdown, { reloadOnZero: true, start: 1631283002 }),
                            React.createElement("div", null, moment().add(1, 'minute').format('x')),
                            React.createElement("input", { type: "text" }),
                            React.createElement("button", { onClick: () => dispatch({ type: 'appReload' }) }, "Reload"))))))));
};
